<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        Agregar información de residentes
      </h2>
    </div>
    <div class="grid grid-cols-12 mt-5">
      <div class="intro-y col-span-12 lg:col-span-8">
        <form @submit.prevent="uploadData">
          <div class="intro-y box p-5 text-xl">
            <div class="flex flex-col">
              <label class="mt-3 form-label font-bold">
                Seleccione el día
              </label>
              <select
                v-model="dateSelected"
                class="form-select box"
                @change="residentChange"
              >
                <option
                  v-for="(date, key) in dates"
                  :key="key"
                  :value="date.original"
                >
                  {{ date.human }}
                </option>
              </select>
            </div>
            <div class="flex flex-col">
              <label class="mt-3 form-label font-bold">
                Seleccione el residente
              </label>
              <select
                v-model="residentSelected"
                class="form-select box"
                @change="residentChange"
              >
                <option
                  v-for="(resident, key) in residents"
                  :key="key"
                  :value="resident"
                >
                  {{ resident.full_name }}
                </option>
              </select>
              <p
                v-if="residentInformation && residentInformation.day"
                class="ml-auto text-xs mt-2 font-bold"
              >
                Información para actualizar
              </p>
            </div>
            <template v-if="residentSelected && residentInformation">
              <div class="mt-6">
                <label class="form-label">Presión Alta (Sistolica)</label>
                <input
                  v-model.number="residentInformation.sistolica"
                  name="sistolica"
                  type="number"
                  class="form-control w-full"
                  placeholder="Presión Sistolica"
                />
              </div>
              <div class="mt-3">
                <label class="form-label">Presión Baja (Diastolica)</label>
                <input
                  v-model.number="residentInformation.diastolica"
                  type="number"
                  class="form-control w-full"
                  placeholder="Presión Diastolica"
                />
              </div>
              <div class="mt-3">
                <label class="form-label">Pulso (Frecuencia Cardica)</label>
                <input
                  v-model.number="residentInformation.cardiaca"
                  type="number"
                  class="form-control w-full"
                  placeholder="Frecuencia Cardica"
                />
              </div>
              <div class="mt-3">
                <label for="crud-form-4" class="form-label">Oxigenación</label>
                <div class="input-group">
                  <input
                    v-model.number="residentInformation.oxigeno"
                    type="number"
                    class="form-control"
                    placeholder="Oxigeno"
                  />
                  <div id="input-group-2" class="input-group-text">%</div>
                </div>
              </div>
              <div class="mt-3">
                <label class="form-label">Azucar en la sangre (Glucosa)</label>
                <input
                  v-model.number="residentInformation.glucosa"
                  type="number"
                  class="form-control w-full"
                  placeholder="Glucosa"
                />
              </div>
              <div class="mt-3">
                <label class="form-label">Temperatura</label>
                <input
                  v-model.number="residentInformation.temperatura"
                  type="number"
                  class="form-control w-full"
                  placeholder="Temperatura"
                  step="0.1"
                />
              </div>
              <div class="mt-3">
                <label class="form-label">Frecuencia respiratoria</label>
                <input
                  v-model.number="residentInformation.respiratoria"
                  type="number"
                  class="form-control w-full"
                  placeholder="Frecuencia respiratoria"
                />
              </div>
              <div class="mt-3">
                <label class="form-label">Peso (en Kg)</label>
                <label
                  class="text-theme-24 ml-5 mt-2"
                  v-if="residentInformation.peso >= 180"
                >
                  El peso no debe de pasar de 180 kg
                </label>
                <input
                  v-model.number="residentInformation.peso"
                  type="number"
                  class="form-control w-full"
                  placeholder="Peso"
                />
              </div>
              <hr />
              <div class="mt-3">
                <label class="form-label">Alimentación - Desayuno</label>
                <select
                  v-model.number="residentInformation.desayuno"
                  class="form-select box"
                >
                  <option disabled :value="null">Seleccione una opción</option>
                  <option :value="3">Bueno</option>
                  <option :value="2">Regular</option>
                  <option :value="2">Malo</option>
                </select>
              </div>
              <div class="mt-3">
                <label class="form-label">Alimentación - Comida</label>
                <select
                  v-model.number="residentInformation.comida"
                  class="form-select box"
                >
                  <option disabled :value="null">Seleccione una opción</option>
                  <option :value="3">Bueno</option>
                  <option :value="2">Regular</option>
                  <option :value="2">Malo</option>
                </select>
              </div>

              <div class="mt-3">
                <label class="form-label">Alimentación - Cena</label>
                <select
                  v-model.number="residentInformation.cena"
                  class="form-select box"
                >
                  <option disabled :value="null">Seleccione una opción</option>
                  <option :value="3">Bueno</option>
                  <option :value="2">Regular</option>
                  <option :value="2">Malo</option>
                </select>
              </div>
              <div class="mt-3">
                <label>Prescripción médica (Médico o especialista)</label>
                <div class="mt-2">
                  <ClassicEditor
                    v-model="residentInformation.med_notas"
                    :editor="classicEditor"
                  />
                </div>
              </div>
              <div class="mt-3">
                <label>Bitácora personal</label>
                <div class="mt-2">
                  <ClassicEditor
                    v-model="residentInformation.notas"
                    :editor="classicEditor"
                  />
                </div>
              </div>
              <div class="text-right mt-5">
                <button
                  type="submit"
                  :disabled="
                    residentInformation.peso && residentInformation.peso >= 180
                  "
                  class="btn btn-primary w-24"
                >
                  Subir
                </button>
              </div>
            </template>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  components: {},
  data() {
    return {
      residents: undefined,
      moment: moment,
      dateSelected: '',
      residentSelected: undefined,
      editorData: '',
      classicEditor: ClassicEditor,
      residentDefaultInformation: {
        sistolica: null,
        diastolica: null,
        cardiaca: null,
        oxigeno: null,
        glucosa: null,
        temperatura: null,
        respiratoria: null,
        desayuno: null,
        comida: null,
        cena: null,
        peso: null,
        notas: '',
        med_notas: ''
      },
      residentInformation: undefined,
      dates: []
    }
  },
  computed: {},
  beforeMount() {
    for (let i = 0; i < 30; i++) {
      let date = this.moment()
      date = date.subtract(i, 'day')
      this.dates.push({
        human: date.format('DD-MM-YYYY'),
        original: date.format('YYYY-MM-DD')
      })
    }
    this.dateSelected = this.dates[0].original
    this.getUsers()
  },
  methods: {
    async getUsers() {
      const isAdmin =
        this.$store.state.auth.user.role.role.toUpperCase() === 'ADMIN'
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = isAdmin
          ? await this.axios.get('/residents', {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            })
          : await this.axios.get(
              `/client-by-id/${this.$store.state.auth.user.id}`,
              {
                headers: {
                  Authorization: `Bearer ${this.$store.state.auth.token}`
                }
              }
            )
        if (isAdmin) {
          if (Array.isArray(response.data) && response.data.length) {
            this.residents = response.data
            this.residentSelected = this.residents[0]
            const medicalInformationResident = await this.getMedicalResidentInformation()
            this.residentInformation = medicalInformationResident
              ? {
                  ...medicalInformationResident,
                  notas: medicalInformationResident.notas || '',
                  med_notas: medicalInformationResident.med_notas || ''
                }
              : {
                  ...this.residentDefaultInformation
                }
          }
        } else {
          if (
            response.data &&
            Array.isArray(response.data.residents) &&
            response.data.residents.length
          ) {
            this.residents = response.data.residents
            this.residentSelected = this.residents[0]
            const medicalInformationResident = await this.getMedicalResidentInformation()
            this.residentInformation = medicalInformationResident
              ? {
                  ...medicalInformationResident,
                  notas: medicalInformationResident.notas || '',
                  med_notas: medicalInformationResident.med_notas || ''
                }
              : {
                  ...this.residentDefaultInformation
                }
          }
        }
      } catch (error) {
        if (error.response) {
          console.error(error.response)
        }
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async residentChange() {
      this.$store.commit('main/setShowSpinner', true)
      const medicalInformationResident = await this.getMedicalResidentInformation()
      this.residentInformation = medicalInformationResident
        ? {
            ...medicalInformationResident,
            notas: medicalInformationResident.notas || '',
            med_notas: medicalInformationResident.med_notas || ''
          }
        : {
            ...this.residentDefaultInformation
          }
      this.$store.commit('main/setShowSpinner', false)
    },
    async uploadData() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const request = { ...this.residentInformation }
        Object.keys(request).forEach(key => {
          request[key] = request[key] || null
        })
        await this.axios.post(
          '/set-medical-resident-information',
          {
            ...request,
            resident_id: this.residentSelected.id,
            date_selected: this.dateSelected
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.$toast.success(`Información agregada a ${request.full_name}`, {
          position: 'top-right'
        })
        const medicalInformationResident = await this.getMedicalResidentInformation()
        this.residentInformation = {
          ...medicalInformationResident,
          notas: medicalInformationResident.notas || '',
          med_notas: medicalInformationResident.med_notas || ''
        }
      } catch (error) {
        console.log(error)
        this.$toast.error(
          `Ocurrió un error al agregar la información de ${this.residentSelected.full_name}`,
          {
            position: 'top-right'
          }
        )
        if (error.response) {
          console.error(error.response)
        }
      } finally {
        window.scrollTo(0, 0)
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async getMedicalResidentInformation() {
      try {
        const response = await this.axios.get(
          `/medical-resident-information-by-date/${this.residentSelected.id}/${this.dateSelected}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        return response.data
      } catch (error) {
        if (error.response) {
          console.error(error.response)
        }
      }
    }
  }
}
</script>
